import {Fragment, useState} from 'react';
import React from "react";
import ListEdit from "../UI/ListEdit";
import {useMollieSettlements} from "../../hooks/useMollieSettlements";
import {convertToOptionalDisplayDate, getSettlementAmountCell} from "../../utility/utility";
import {useNavigate} from "react-router-dom";

const MollieSettlementList = (props) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {settlements, pagination, isLoading} = useMollieSettlements(props.fromDate, props.toDate, page, pageSize, 0);
    const navigate = useNavigate();

    const settlementList = settlements.map((item) => {
        return {
            settlementId : item.settlementId,
            reference    : item.reference,
            settledAt    : convertToOptionalDisplayDate(item.settledAt),
            status       : item.status,
            gross        : getSettlementAmountCell(item.grossAfterRefunds, item.currency),
            fee          : getSettlementAmountCell(item.fee, item.currency),
            net          : getSettlementAmountCell(item.net, item.currency)
        };
    });

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    // Same money columns as the Stripe list: gross - fee = payout. Mollie reports
    // its gross before refunds and the refunds separately, so the backend does the
    // subtraction and hands it over as grossAfterRefunds - deliberately a field of
    // its own rather than arithmetic hidden in here. The untouched gross and
    // refunds stay in the response for the CSV report and for reconciling against
    // the Mollie dashboard, which calls the full gross "Revenue".
    const listHeaders = [
        'Id',
        'Reference',
        'Settled on',
        'Status',
        'Gross',
        'Fee',
        'Payout',
        'Actions'
    ];

    const columns = {
        functionParams : ['settlementId'],
        dataKeys       : [
            'settlementId',
            'reference',
            'settledAt',
            'status',
            'gross',
            'fee',
            'net'
        ],
    }

    const handleShowIconClick = (settlementId) => {
        navigate('/payouts/' + settlementId + '/transactions?provider=mollie');
    }

    return <Fragment>
        <ListEdit
            headers={listHeaders}
            items={settlementList}
            columns={columns}
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            handleShowIconClick={handleShowIconClick}
        />
        {!isLoading && settlements.length === 0 && (
            <p className="text-sm text-gray-500">
                No settlements found. Mollie only reports settlements in live mode, so this list
                stays empty on development and staging environments.
            </p>
        )}
    </Fragment>;
}

export default MollieSettlementList;
